import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { CdsPushStoreService, SubscriptionKind, isFixtureSlimUpdateEnvelope, updateFixture } from '@frontend/sports/content-distribution/feature';
import { merge } from 'rxjs';

import { DayOfRaceModel } from '../../../horse-racing-shared/model/day-of-race.model';

@Component({
    template: '',
    standalone: false,
})
export abstract class BaseDayOfRaceComponent extends OnRouteResolve<DayOfRaceModel> implements OnDestroy {
    model: Nullable<DayOfRaceModel> = null;
    sportId: SportConstant;

    protected constructor(
        route: ActivatedRoute,
        protected changeDetector: ChangeDetectorRef,
        private pushService: CdsPushStoreService,
    ) {
        super(route);
    }

    onRouteResolved(model: DayOfRaceModel): void {
        this.model = model;
        this.subscribeToFixtures();
        this.changeDetector.markForCheck();
        this.sportId = this.route.snapshot.data.sport;
    }

    ngOnDestroy(): void {
        this.model = null;
    }

    private subscribeToFixtures(): void {
        merge(...this.model!.fixtures.map((f) => this.pushService.subscribeToFixture(f, SubscriptionKind.Slim)))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((message) => {
                if (isFixtureSlimUpdateEnvelope(message)) {
                    if (this.model) {
                        // safety check.
                        this.model = {
                            ...this.model,
                            fixtures: this.model.fixtures.map((f) => {
                                return f.id === message.payload.fixtureId ? updateFixture(f, message) : f;
                            }),
                        };
                        this.changeDetector.markForCheck();
                    }
                }
            });
    }
}
